import { AIProvider, AIServiceError } from '../types';

export function createServiceError(
  message: string,
  provider: AIProvider,
  statusCode?: number,
  originalError?: any
): AIServiceError {
  return new AIServiceError(
    message,
    provider,
    statusCode,
    originalError instanceof Error ? originalError : undefined
  );
}

export function parseErrorResponse(
  provider: AIProvider,
  response: Response,
  errorPrefix: string = '请求失败'
): Promise<AIServiceError> {
  return response.text()
    .then(errorText => {
      let errorMessage = `${errorPrefix} (${response.status})`;
      
      try {
        const errorJson = JSON.parse(errorText);
        const detailMessage = 
          errorJson.error?.message ||
          errorJson.message ||
          errorJson.error ||
          errorText;
          
        errorMessage = `${errorPrefix} (${response.status}): ${detailMessage}`;
      } catch (e) {
        // 如果解析JSON失败，使用原始错误文本
        if (errorText) {
          errorMessage = `${errorPrefix} (${response.status}): ${errorText}`;
        }
      }
      
      return new AIServiceError(errorMessage, provider, response.status);
    })
    .catch(() => {
      // 如果无法读取响应文本
      return new AIServiceError(
        `${errorPrefix} (${response.status}): ${response.statusText}`,
        provider,
        response.status
      );
    });
} 